export const KEY_TRANSLATIONS = 'TRANSLATIONS';
export const KEY_USER_CALLBACK = 'USER-CALLBACK';
export const KEY_USER_ORIGIN = 'USER-ORIGIN';
